(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fuserig-lineup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fuserig-lineup')) {
    customElements.define('fuserig-lineup', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.controller) return;
        const track = this.querySelector('.fr-lineup__grid');
        if (!track) return;
        const cards = [...track.querySelectorAll('.fr-lineup__card')];
        const dots = [...this.querySelectorAll('[data-fr-slide]')];
        const mobile = matchMedia('(max-width: 760px)');
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        track.toggleAttribute('data-single', cards.length < 2);

        const update = () => {
          this.updateFrame = null;
          if (!mobile.matches) return;
          const bounds = track.getBoundingClientRect();
          const center = bounds.left + bounds.width / 2;
          let nearest = 0;
          let distance = Infinity;
          cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const delta = Math.abs(rect.left + rect.width / 2 - center);
            if (delta < distance) {
              nearest = index;
              distance = delta;
            }
          });
          dots.forEach((dot, index) => {
            if (index === nearest) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        };

        dots.forEach(dot => dot.addEventListener('click', () => {
          if (!mobile.matches) return;
          const card = cards[Number(dot.dataset.frSlide)];
          if (!card) return;
          const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollTo({ left, behavior: motion.matches ? 'instant' : 'smooth' });
        }, { signal }));

        track.addEventListener('scroll', () => {
          if (this.updateFrame != null) return;
          this.updateFrame = requestAnimationFrame(update);
        }, { passive: true, signal });

        const resize = () => {
          if (mobile.matches && cards.length > 1) track.setAttribute('tabindex', '0');
          else track.removeAttribute('tabindex');
          update();
        };
        this.observer = new ResizeObserver(resize);
        this.observer.observe(track);
        window.addEventListener('resize', resize, { signal });
        resize();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        if (this.updateFrame != null) cancelAnimationFrame(this.updateFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
        this.updateFrame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
